module.exports = __webpack_public_path__ + "img/host.8e7642aa.svg";